<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-date-picker
                    :end-validations="validations.periodo"
                    :range-inline="false"
                    :start-validations="validations.periodo"
                    end-label="Até"
                    range
                    start-label="Período de"
                    v-model="model.periodo"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.unidades"
                    :validations="validations.unidade"
                    @change="handleUnidadeChange"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.infraestruturas"
                    :validations="validations.infraestrutura"
                    @change="handleInfraestruturaChange"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.ocupacoes"
                    :validations="validations.ocupacao"
                    @change="handleOcupacaoChange"
                    label="CBO"
                    show-default-option
                    text-field="descricao"
                    v-model="model.ocupacaoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.especialidades"
                    :validations="validations.especialidade"
                    label="Especialidade"
                    show-default-option
                    text-field="nome"
                    v-model="model.especialidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.usuarios"
                    default-option-text="Todos"
                    label="Profissional"
                    show-default-option
                    text-field="nome"
                    v-model="model.usuarioId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
                unidade: {required: true},
                infraestrutura: {required:true},
                ocupacao: {required: true},
                especialidade: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            jornadaBloqueio: this.getConectaSusRepository('ambulatorio.jornadaBloqueio'),
        }
    },
    data: () => ({
        form: null,
        model: null,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.jornadaBloqueio.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)

                        this.model.periodo.start = this.others.moment(this.model.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD')
                        this.model.periodo.end = this.others.moment(this.model.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.jornadaBloqueio.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.infraestruturaId = null
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null

            if (value === null) return

            this.getInfraestruturas(value)
        },
        handleInfraestruturaChange(value) {
            this.form.ocupacoes = []
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.ocupacaoId = null
            this.model.especialidadeId = null
            this.model.usuarioId = null

            if (value === null) return

            this.getOcupacoes(value)
        },
        handleOcupacaoChange(value) {
            this.form.especialidades = []
            this.form.usuarios = []
            this.model.especialidadeId = null
            this.model.usuarioId = null

            if (value === null) return

            this.getEspecialidades(value)
            this.getUsuarios(this.model.infraestruturaId, value)
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        infraestruturaId: this.model.infraestruturaId,
                        especialidadeId: this.model.especialidadeId,
                        usuarioId: this.model.usuarioId,
                        inicio: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                        fim: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                    }

                    if (this.id) {
                        this.repositories.jornadaBloqueio.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.jornadaBloqueio.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        async getInfraestruturas(unidadeId) {
            const request = {
                listar: 'infraestruturas',
                unidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.jornadaBloqueio.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.infraestruturas = response.data

                if (this.form.infraestruturas.length === 1) {
                    const selected = this.form.infraestruturas[0]
                    this.model.infraestruturaId = selected.id

                    this.getOcupacoes(this.model.infraestruturaId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getOcupacoes(infraestruturaId) {
            const request = {
                listar: 'ocupacoes',
                infraestruturaId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.jornadaBloqueio.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.ocupacoes = response.data

                if (this.form.ocupacoes.length === 1) {
                    const selected = this.form.ocupacoes[0]
                    this.model.ocupacaoId = selected.id

                    this.getEspecialidades(this.model.ocupacaoId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getEspecialidades(ocupacaoId) {
            const request = {
                listar: 'especialidades',
                ocupacaoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.jornadaBloqueio.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.especialidades = response.data

                if (this.form.especialidades.length === 1) {
                    const selected = this.form.especialidades[0]
                    this.model.especialidadeId = selected.id
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getUsuarios(infraestruturaId, ocupacaoId) {
            const request = {
                listar: 'usuarios',
                infraestruturaId,
                ocupacaoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.jornadaBloqueio.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.usuarios = response.data
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: { type: Number },
    },
}
</script>